<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper reports" style="opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div class="modal reports" style="top: 0;">
				<div class="modalContent">
					<div class="modalDecoration"></div>
					<div class="functionPanel unselectable">
						<a class="closeWindow clickable" @click="onModalClose(close)">
							<div class="decoration" content="Закрыть" v-tippy="{placement: 'bottom'}">
								<i class="action_cancel_tiny_flat_black"></i>
							</div>
						</a>
					</div>
					<div>
						<div class="contentHeader unselectable">
							<h2 class="msAntiScroll drag" draggable="true">
								<span>Логово разбойников</span>
							</h2>
						</div>
					</div>
					<div class="heightTransitionContent">
						<div class="contentTabulation">
							<div class="tabulationContent scrollable scrollingDisabled">
								<div class="scrollContentOuterWrapper disableScrolling">
									<div class="scrollContent disableScrolling">
										<div class="scrollContentInnerWrapper">
											<div ng-transclude="">
												<div class="mapCellDetails" ng-controller="mapCellDetailsCtrl">
													<div dynamic="" scrollable="" class="scrollable">
														<div class="scrollContentOuterWrapper active" style="width: 610px;">
															<div class="scrollContent" dynamic-height="true" style="width: 630px; overflow-y: auto; max-height: 453px;">
																<div class="scrollContentInnerWrapper" ng-transclude="" style="width: 610px;">
																	<div ng-include="" src="'tpl/mapCellDetails/partials/header.html'">
																		<div class="mapContainer npcVillageRobber">
																			<!-- ngIf: mapDetails.isWonder -->
																			<!-- ngIf: fieldType == 'oasis' -->
																			<div class="robberIllu" ng-if="fieldType == 'npcVillageRobber'"></div>
																			<!-- ngIf: cellData.menhir -->
																			<!-- ngIf: fieldType != 'oasis' && fieldType != 'npcVillageRobber' && !mapDetails.isWonder && !cellData.menhir -->
																			<!-- ngIf: mapDetails.isWonder -->
																			<!-- ngIf: showAttack && attackingTroops.cnt == 0 -->
																			<!-- ngIf: attackingTroops.cnt > 0 -->
																			<!-- ngIf: mapDetails.npcInfo.type == 8 -->
																			<!-- ngIf: fieldType == 'oasis' -->
																			<!-- ngIf: fieldType == 'oasis' -->
																		</div>
																	</div>
																	<div class="otherContainer npcVillageRobber">
																		<div ng-include="" src="'tpl/mapCellDetails/partials/bodyTop.html'">
																			<div class="splitContainer npcVillageRobber">
																				<!-- ngIf: fieldType == 'village' && mapDetails.wwValues -->
																				<!-- ngIf: fieldType == 'village' -->
																				<!-- ngIf: fieldType == 'oasis' -->
																				<div ng-if="fieldType == 'npcVillageRobber' || fieldType == 'npcVillageGovernor'">
																					<!-- ngIf: mapDetails.npcInfo.type == Village.TYPE_KINGDOM_ROBBER -->
																					<!-- ngIf: mapDetails.npcInfo.type == Village.TYPE_GOVERNOR_NPC_VILLAGE -->
																					<div ng-if="mapDetails.npcInfo.type != Village.TYPE_KINGDOM_ROBBER && mapDetails.npcInfo.type != Village.TYPE_GOVERNOR_NPC_VILLAGE" class="normal">
																						<div class="contentBox">
																							<div ng-include="" src="'tpl/mapCellDetails/partials/npcVillageDetails.html'">
																								<div class="villageDetails contentBoxHeader headerColored">
																									<h6>
																										<span translate=""><span>Информация</span></span>
																										<span class="coordinateWrapper" coordinates="" x="-7" y="11">
																											<a ng-if="hasLink" clickable="$root.openPage('map', 'centerId', '537247737_1708113071.1');" class="clickable">
																												<span class="coordinates coordinatesWrapper " ng-bind-html=" coord | bidiCoordinate:x:y "><span class="coordinateX">(-7</span><span class="coordinatePipe">|</span><span class="coordinateY">11)</span></span>
																											</a>
																											<!-- ngIf: !hasLink -->
																										</span>
																									</h6>
																								</div>
																								<div class="contentBoxBody">
																									<table class="transparent">
																										<tbody>
																											<tr>
																												<th translate=""><span>Владелец</span></th>
																												<td><div class="longTitle">
																													<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable disabled" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="-1" playername="">Разбойник</a></div>
																												</td>
																											</tr>
																											<tr>
																												<th translate=""><span>Народ</span></th>
																												<td translate="" options="2"><span>Германцы</span></td>
																											</tr>
																										</tbody>
																									</table>
																									<div class="npcDescription" translate="" options="5"><span>Совершая набеги на логова разбойников, ты можешь добыть ресурсы и краденые ценности.</span></div>
																								</div>
																							</div>
																						</div>
																						<div class="contentBox lootContainer">
																							<div ng-include="" src="'tpl/mapCellDetails/partials/loot.html'">
																								<div class="villageDetails contentBoxHeader headerColored">
																									<h6 translate=""><span>Добыча</span></h6>
																								</div>
																								<div class="contentBoxBody">
																									<div class="loot">
																										<div class="horizontalLine"></div>
																										<div class="verticalLine"></div>
																										<!-- ngIf: player.isKing() -->
																										<div ng-if="!player.isKing()">
																											<display-resources resources="selectedCharge.loot" stolen-goods="selectedCharge.treasures">
																												<div class="costs max3digits">
																													<span ng-if="!checkStorage">
																														<span ng-repeat="(index, type) in resTypes" class="resource woodValue" ng-if="resourceVisibility[index]" ng-class="{notEnough: !enoughResources(index), enough: enoughResources(index) && colorPositive}" content="Древесина" v-tippy="{placement: 'bottom'}" tooltip-translate="Resource_1">
																															<i class="unit_wood_small_illu resType1"></i>
																															<span class="resourceValue" ng-if="!onlyProductionPerHour" ng-class="::{strikethrough: showAsOldResources}">467</span>
																															<!-- ngIf: ::numberUnit=='production' -->
																															<!-- ngIf: productionPerHour[index] || productionPerHour[index] == 0 -->
																														</span>
																														<span ng-repeat="(index, type) in resTypes" class="resource clayValue" ng-if="resourceVisibility[index]" ng-class="{notEnough: !enoughResources(index), enough: enoughResources(index) && colorPositive}" content="Глина" v-tippy="{placement: 'bottom'}" tooltip-translate="Resource_2">
																															<i class="unit_clay_small_illu resType2"></i>
																															<span class="resourceValue" ng-if="!onlyProductionPerHour" ng-class="::{strikethrough: showAsOldResources}">578</span>
																															<!-- ngIf: ::numberUnit=='production' -->
																															<!-- ngIf: productionPerHour[index] || productionPerHour[index] == 0 -->
																														</span>
																														<span ng-repeat="(index, type) in resTypes" class="resource ironValue" ng-if="resourceVisibility[index]" ng-class="{notEnough: !enoughResources(index), enough: enoughResources(index) && colorPositive}" content="Железо" v-tippy="{placement: 'bottom'}" tooltip-translate="Resource_3">
																															<i class="unit_iron_small_illu resType3"></i>
																															<span class="resourceValue" ng-if="!onlyProductionPerHour" ng-class="::{strikethrough: showAsOldResources}">338</span>
																															<!-- ngIf: ::numberUnit=='production' -->
																															<!-- ngIf: productionPerHour[index] || productionPerHour[index] == 0 -->
																														</span>
																														<span ng-repeat="(index, type) in resTypes" class="resource cropValue" ng-if="resourceVisibility[index]" ng-class="{notEnough: !enoughResources(index), enough: enoughResources(index) && colorPositive}" content="Зерно" v-tippy="{placement: 'bottom'}" tooltip-translate="Resource_4">
																															<i class="unit_crop_small_illu resType4"></i>
																															<span class="resourceValue" ng-if="!onlyProductionPerHour" ng-class="::{strikethrough: showAsOldResources}">219</span>
																															<!-- ngIf: ::numberUnit=='production' -->
																															<!-- ngIf: productionPerHour[index] || productionPerHour[index] == 0 -->
																														</span>
																													</span>
																													<!-- ngIf: checkStorage -->

																													<!-- ngIf: (consumption || consumption == 0) && consumption != 'false' -->
																													<!-- ngIf: population || population == 0 -->

																													<!-- ngIf: treasures || treasures == 0 -->

																													<span class="resource treasureValue" ng-if="stolenGoods || stolenGoods == 0" content="Краденные ценности" v-tippy="{placement: 'bottom'}" tooltip-translate="Resource.StolenGoods">
																														<i class="unit_stolenGoods_small_illu"></i>0
																													</span>

																													<!-- ngIf: time || time == 0 -->

																													<!-- ngIf: enoughResSecs == -1 -->
																													<!-- ngIf: enoughResSecs > 0 -->
																													<!-- ngIf: capacityHint -->

																													<div class="iconButton premium npcTrade ng-hide" ng-show="showNpc != undefined"><i class="feature_npcTrader_small_flat_black"></i></div>
																												</div>
																											</display-resources>
																										</div>
																									</div>
																								</div>
																							</div>
																						</div>
																						<div class="contentBox gradient troopContainer">
																							<div ng-include="" src="'tpl/mapCellDetails/partials/troops.html'">
																								<div class="villageDetails contentBoxHeader headerColored">
																									<h6 translate=""><span>Войска</span></h6>
																								</div>
																								<div class="contentBoxBody">
																									<div troops-details="" troop-data="selectedCharge.troops">
																										<table class="troopsTable teuton">
																											<tbody class="troopsIconRow">
																												<tr>
																													<td ng-repeat="n in []|range:1:11" class="unit1">
																														<i class="unitSmall teuton unitType1 inactive" unit-icon="" data="11" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																																						|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																																			clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
																														<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
																														<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
																													</td>
																													<td ng-repeat="n in []|range:1:11" class="unit2">
																														<i class="unitSmall teuton unitType2 inactive" unit-icon="" data="12" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																																						|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																																			clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
																														<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
																														<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
																													</td>
																													<td ng-repeat="n in []|range:1:11" class="unit3">
																														<i class="unitSmall teuton unitType3 inactive" unit-icon="" data="13" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																																						|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																																			clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
																														<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
																														<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
																													</td>
																													<td ng-repeat="n in []|range:1:11" class="unit4">
																														<i class="unitSmall teuton unitType4 inactive" unit-icon="" data="14" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																																						|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																																			clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
																														<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
																														<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
																													</td>
																													<td ng-repeat="n in []|range:1:11" class="unit5">
																														<i class="unitSmall teuton unitType5 inactive" unit-icon="" data="15" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																																						|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																																			clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
																														<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
																														<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
																													</td>
																													<td ng-repeat="n in []|range:1:11" class="unit6">
																														<i class="unitSmall teuton unitType6 inactive" unit-icon="" data="16" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																																						|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																																			clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
																														<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
																														<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
																													</td>
																													<td ng-repeat="n in []|range:1:11" class="unit7">
																														<i class="unitSmall teuton unitType7 inactive" unit-icon="" data="17" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																																						|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																																			clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
																														<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
																														<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
																													</td>
																													<td ng-repeat="n in []|range:1:11" class="unit8">
																														<i class="unitSmall teuton unitType8 inactive" unit-icon="" data="18" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																																						|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																																			clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
																														<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
																														<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
																													</td>
																													<td ng-repeat="n in []|range:1:11" class="unit9">
																														<i class="unitSmall teuton unitType9 inactive" unit-icon="" data="19" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																																						|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																																			clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
																														<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
																														<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
																													</td>
																													<td ng-repeat="n in []|range:1:11" class="unit10">
																														<i class="unitSmall teuton unitType10 inactive" unit-icon="" data="20" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																																						|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																																			clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
																														<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
																														<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
																													</td>
																													<td ng-repeat="n in []|range:1:11" class="hero">
																														<i class="unitSmall hero_illu inactive" unit-icon="" data="hero" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																																						|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																																			clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
																														<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
																														<div class="horizontalLine" ng-if="troopData['originalTroops'] || !troopData['inputTroops']"></div>
																													</td>
																												</tr>
																											</tbody>
																											<tbody ng-if="troopData[troopsType+'Troops']" class="originalTroops" ng-repeat="troopsType in ['original', 'input', 'lost', 'trapped']">
																												<!-- ngIf: troopsType == 'trapped' -->
																												<tr>
																													<td ng-repeat="n in [] | range:1:11" class="unit1">
																														<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
																														<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

																														<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
																														<!-- ngIf: troopsType == 'input' -->
																													</td>
																													<td ng-repeat="n in [] | range:1:11" class="unit2">
																														<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
																														<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

																														<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
																														<!-- ngIf: troopsType == 'input' -->
																													</td>
																													<td ng-repeat="n in [] | range:1:11" class="unit3">
																														<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
																														<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

																														<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
																														<!-- ngIf: troopsType == 'input' -->
																													</td>
																													<td ng-repeat="n in [] | range:1:11" class="unit4">
																														<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
																														<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

																														<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
																														<!-- ngIf: troopsType == 'input' -->
																													</td>
																													<td ng-repeat="n in [] | range:1:11" class="unit5">
																														<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
																														<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

																														<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
																														<!-- ngIf: troopsType == 'input' -->
																													</td>
																													<td ng-repeat="n in [] | range:1:11" class="unit6">
																														<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
																														<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

																														<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
																														<!-- ngIf: troopsType == 'input' -->
																													</td>
																													<td ng-repeat="n in [] | range:1:11" class="unit7">
																														<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
																														<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

																														<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
																														<!-- ngIf: troopsType == 'input' -->
																													</td>
																													<td ng-repeat="n in [] | range:1:11" class="unit8">
																														<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
																														<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

																														<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
																														<!-- ngIf: troopsType == 'input' -->
																													</td>
																													<td ng-repeat="n in [] | range:1:11" class="unit9">
																														<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
																														<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

																														<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
																														<!-- ngIf: troopsType == 'input' -->
																													</td>
																													<td ng-repeat="n in [] | range:1:11" class="unit10">
																														<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
																														<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

																														<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
																														<!-- ngIf: troopsType == 'input' -->
																													</td>
																													<td ng-repeat="n in [] | range:1:11" class="hero">
																														<span ng-if="troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0)">-</span>
																														<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

																														<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
																														<!-- ngIf: troopsType == 'input' -->
																													</td>
																												</tr>
																											</tbody>
																											<!-- ngIf: troopData.supply -->
																											<!-- ngIf: troopData.cagedAnimals -->
																										</table>
																									</div>
																								</div>
																							</div>
																						</div>
																					</div>
																				</div>
																				<!-- ngIf: fieldType == 'unhabitable' -->
																				<!-- ngIf: fieldType == 'habitable' -->
																			</div>
																		</div>
																		<div ng-include="" src="'tpl/mapCellDetails/partials/bodyBottom.html'">
																			<!-- ngIf: fieldType == 'oasis' -->

																			<!-- ngIf: fieldType == 'village' && mapDetails.isWonder && !mapDetails.isConquered -->

																			<div class="tributeCropContainer">
																				<div class="tributes contentBox gradient ng-hide" ng-show="showTributes">
																					<div class="contentBoxBody">
																						<display-resources resources="village.tributes" treasures="village.tributeTreasures" hide-zero="true">
																							<div class="costs max1digits">
																								<span ng-if="!checkStorage">
																									<!-- ngRepeat: (index, type) in resTypes --><!-- ngIf: resourceVisibility[index] --><!-- end ngRepeat: (index, type) in resTypes --><!-- ngIf: resourceVisibility[index] --><!-- end ngRepeat: (index, type) in resTypes --><!-- ngIf: resourceVisibility[index] --><!-- end ngRepeat: (index, type) in resTypes --><!-- ngIf: resourceVisibility[index] --><!-- end ngRepeat: (index, type) in resTypes -->
																								</span>
																								<!-- ngIf: checkStorage -->

																								<!-- ngIf: (consumption || consumption == 0) && consumption != 'false' -->
																								<!-- ngIf: population || population == 0 -->

																								<!-- ngIf: treasures || treasures == 0 -->

																								<!-- ngIf: stolenGoods || stolenGoods == 0 -->

																								<!-- ngIf: time || time == 0 -->

																								<!-- ngIf: enoughResSecs == -1 -->
																								<!-- ngIf: enoughResSecs > 0 -->
																								<!-- ngIf: capacityHint -->

																								<div class="iconButton premium npcTrade ng-hide" ng-show="showNpc != undefined"><i class="feature_npcTrader_small_flat_black"></i></div>
																							</div>
																						</display-resources>
																						<div class="barView">
																							<div class="actualTributes">0/0</div>
																							<div class="populationBar progressbar" progressbar="" type="green" perc="NaN" marker="NaN">
																								<!-- ngIf: ::labelIcon -->
																								<div class="progress">
																									<!-- ngIf: steps -->
																									<div class="bar positive perc green"></div>
																									<div class="bar additionalBar additionalPerc"></div>
																									<div class="marker">
																										<div class="markerInner"></div>
																									</div>
																									<!-- ngIf: ::showCountdown -->
																									<!-- ngIf: ::label -->
																									<!-- ngIf: ::percTooltip -->
																								</div>
																							</div>
																						</div>
																						<button clickable="fetchTributes()" ng-class="{disabled: !village.canFetchTributes || !village.allowTributeCollection || !village.protectionGranted || !activeTreasury || (!territoryConnected && village.type != Village.TYPE_GOVERNOR_NPC_VILLAGE)}" play-on-click="16" tooltip="" tooltip-translate-switch="{
																							'ContextMenu.button.fetchTribute.denied': true,
																							'ContextMenu.button.fetchTribute.unprotected': true,
																							'Tributes.VillageNotGeneratingInfluence': true,
																							'Tributes.VillageNotConnected': false
																						}" class="clickable disabled">
																							<div class="content">
																								<span ng-transclude="" class="innerText">
																									<span translate=""><span>Собрать дань</span></span>
																								</span>
																								<!-- ngIf: price > 0 || forceGoldUsage -->
																								<!-- ngIf: price == -1 && !forceGoldUsage -->
																								<div class="animationOverlay"></div>
																								<i class="checkmark action_check_small_flat_white"></i>
																								<i class="checkmark action_check_small_flat_black"></i>
																								<i class="checkmark action_check_small_flat_red"></i>
																							</div>
																						</button>
																					</div>
																				</div>
																				<!-- ngIf: sharedInformations.cropDetails != null -->
																			</div>

																			<p ng-show="error" class="error ng-hide"></p>

																			<div ng-if="fieldType == 'village' || fieldType == 'npcVillageRobber' || fieldType == 'npcVillageGovernor'">
																				<!-- ngRepeat: troopDetails in troopsHere -->
																			</div>

																			<!-- ngIf: sharedInformations.stationedTroops.length > 0 -->
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div class="cellActionContainer">
														<div class="iconButton centerMapButton clickable" content="Центрировать" v-tippy="{placement: 'top'}" tooltip-translate="CellDetails.CenterMap" clickable="openPage('map', 'centerId', '537247737_1708113071.1'); closeWindow(w.name);">
															<i class="symbol_target_small_flat_black"></i>
														</div>
														<div class="options" ng-if="options.length > 0" more-dropdown="" more-dropdown-options="getOptions()" style="position: relative;"><a class="iconButton clickable" clickable="openMoreDropdown()"><!-- ngIf: showCount --><i class="symbol_arrowDown_tiny_illu"></i></a>
															<div class="moreDropDownBody dropdownBody" style="bottom: 0; right: 0; display: block;">
																<ul>
																	<li ng-repeat="option in options" clickable="openWindow('markerMenu',{'cellId': 537247737}); closeMoreDropdown()" class="clickable">Отметить поле</li>
																	<li ng-repeat="option in options" clickable="openInSim(); closeMoreDropdown()" class="clickable">Рассчитать в симуляторе</li>
																</ul>
															</div>
														</div>
														<button class="sendTroopsButton clickable" ng-if="fieldType == 'village' || fieldType == 'oasis' || fieldType == 'npcVillageRobber' || fieldType == 'npcVillageGovernor'" clickable="openWindow('sendTroops', {'x': -7, 'y': 11 })" tooltip="" tooltip-show="false" tooltip-translate="ContextMenu.NoRallyPoint" ng-class="{disabled: !hasRallyPoint}">
															<div class="content">
																<span ng-transclude="" class="innerText">
																	<span translate=""><span>Отправить войска</span></span>
																</span>
																<!-- ngIf: price > 0 || forceGoldUsage -->
																<!-- ngIf: price == -1 && !forceGoldUsage -->
																<div class="animationOverlay"></div>
																<i class="checkmark action_check_small_flat_white"></i>
																<i class="checkmark action_check_small_flat_black"></i>
																<i class="checkmark action_check_small_flat_red"></i>
															</div>
														</button>
														<!-- ngIf: fieldType == 'habitable' && !cellData.menhir -->
														<!-- ngIf: cellData.menhir && cellData.menhir == player.data.playerId -->
														<!-- ngIf: cellData.menhir && cellData.owner == player.data.playerId -->
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="window-overlay"></div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>